module.exports = __webpack_public_path__ + "static/img/Lachie-Neale.7203a2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Lachie-Neale.jpg
// module id = 0WJB
// module chunks = 0